module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Jb.249204d8.png";